export const ToDoList_PirmaryThemes = {
  bgColor: "#fff",
  color: "#343a40",
  bordeButton: "1px solid #343a40",
  borderRadiusButton: "none",
  hoverTextColor: "#fff",
  hoverBgColor: "#343a40",
  borderColor: "#343a40",
};
